// extracted by mini-css-extract-plugin
export default {"Chip":"Tag_Chip__suaNh","Custom":"Tag_Custom__mqr5v","Label":"Tag_Label__XvO9H","Blue":"Tag_Blue__H3sHd","Grey":"Tag_Grey__SKfZd"};